import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ngoTransactions,
  ngoWalletAmount,
} from "appState/api/transaction/transaction";

export const getNgoWalletAmount = createAsyncThunk(
  "transaction/getNgoWalletAmount",
  ngoWalletAmount
);
export const getNgoTransactions = createAsyncThunk(
  "transaction/getNgoTransactions",
  ngoTransactions
);

const initialState = {
  isLoading: false,
  transactions: [],
  transactionsCount: null,
  walletAmount: null,
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNgoTransactions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getNgoTransactions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.transactions = action.payload?.data;
      state.transactionsCount = action.payload?.data?.length;
    });
    builder.addCase(getNgoTransactions.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getNgoWalletAmount.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getNgoWalletAmount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.walletAmount = action.payload?.data?.balance;
    });
    builder.addCase(getNgoWalletAmount.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default transactionSlice.reducer;
